// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/images/light_background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u1TnfvMrVMiJQv0SVa9Q {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
}
.JIQnqpvatFTYukWcOlci {
  font-weight: lighter;
  color: #212121;
  width: 100%;
  line-height: 15px;
  margin: 20% 0 5% 0;
  font-family: noto-sans, sans-serif;
  font-size: 0.7125rem;
}

.gQpiwlCFgYT2tP1idsYw {
  margin-left: 2px;
  padding-bottom: 1px;
  border-bottom-style: solid;
  border-bottom-width: thin;
}

.gQpiwlCFgYT2tP1idsYw:visited,
.gQpiwlCFgYT2tP1idsYw:active {
  color: #0d3c61;
}

.gQpiwlCFgYT2tP1idsYw:hover,
.gQpiwlCFgYT2tP1idsYw:focus {
  color: #0064cb;
  cursor: pointer;
}

.tmov5_buNr8qARfHYf4w {
  width: 750px;
  height: 450px;
  box-shadow:
    0px 6px 6px -3px rgba(0, 0, 0, 0.2),
    0px 10px 14px 1px rgba(0, 0, 0, 0.14),
    0px 4px 18px 3px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  display: flex;
  overflow: hidden;
}

.yigYkHjRfECw7_yagRlv {
  padding: 45px;
  flex: 1;
  max-width: 300px;
  background-color: #fff;
}

.BEi6xLFYzX6AV2dPmuUx {
  flex: 1.5;
  background-color: #f9f9f9;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: right;
}

.gXavcTRnqyXBsnMGtkm1 {
  width: 100%;
}

.ezV_lz2Te6ysynqgXK9l {
  height: 5px;
  width: 60px;
  background-color: #3b5764;
  text-align: left;
}

.gs9_fIl9tam5HEC5lYrq {
  margin-bottom: 15px;
}
`, "",{"version":3,"sources":["webpack://./login/login.module.css"],"names":[],"mappings":"AAAA;EACE,mDAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb;;;wCAGsC;EACtC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".background {\n  background: url(/images/light_background.jpg);\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-size: cover;\n}\n.terms {\n  font-weight: lighter;\n  color: #212121;\n  width: 100%;\n  line-height: 15px;\n  margin: 20% 0 5% 0;\n  font-family: noto-sans, sans-serif;\n  font-size: 0.7125rem;\n}\n\n.termsLink {\n  margin-left: 2px;\n  padding-bottom: 1px;\n  border-bottom-style: solid;\n  border-bottom-width: thin;\n}\n\n.termsLink:visited,\n.termsLink:active {\n  color: #0d3c61;\n}\n\n.termsLink:hover,\n.termsLink:focus {\n  color: #0064cb;\n  cursor: pointer;\n}\n\n.content {\n  width: 750px;\n  height: 450px;\n  box-shadow:\n    0px 6px 6px -3px rgba(0, 0, 0, 0.2),\n    0px 10px 14px 1px rgba(0, 0, 0, 0.14),\n    0px 4px 18px 3px rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n  display: flex;\n  overflow: hidden;\n}\n\n.left {\n  padding: 45px;\n  flex: 1;\n  max-width: 300px;\n  background-color: #fff;\n}\n\n.right {\n  flex: 1.5;\n  background-color: #f9f9f9;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: right;\n}\n\n.loginImg {\n  width: 100%;\n}\n\n.boxUnderImg {\n  height: 5px;\n  width: 60px;\n  background-color: #3b5764;\n  text-align: left;\n}\n\n.formField {\n  margin-bottom: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `u1TnfvMrVMiJQv0SVa9Q`,
	"terms": `JIQnqpvatFTYukWcOlci`,
	"termsLink": `gQpiwlCFgYT2tP1idsYw`,
	"content": `tmov5_buNr8qARfHYf4w`,
	"left": `yigYkHjRfECw7_yagRlv`,
	"right": `BEi6xLFYzX6AV2dPmuUx`,
	"loginImg": `gXavcTRnqyXBsnMGtkm1`,
	"boxUnderImg": `ezV_lz2Te6ysynqgXK9l`,
	"formField": `gs9_fIl9tam5HEC5lYrq`
};
export default ___CSS_LOADER_EXPORT___;
